import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { TeamMembersActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createTeamMember = (data): any => action(types.CREATE_TEAM_MEMBER_REQUESTED, data);

export const updateTeamMember = (data): any => action(types.UPDATE_TEAM_MEMBER_REQUESTED, data);

export const deleteTeamMember = (teamMember, callbackFunction = undefined): any => action(types.DELETE_TEAM_MEMBER_REQUESTED, { teamMember, callbackFunction });

export const getTeamMember = (teamMemberId): any => action(types.GET_TEAM_MEMBER_REQUESTED, teamMemberId);

export const getAllTeamMembers = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_TEAM_MEMBERS_REQUESTED, { pagination, compile });

export const getAllTeamMembersTeamMemberView = (
  pagination: IPagination = undefined,
  compile = true,
  teamCode = undefined,
  teamMemberCode = undefined,
): any => action(types.GET_ALL_TEAM_MEMBERS_REQUESTED, {
  pagination,
  compile,
  teamMemberView: true,
  teamCode,
  teamMemberCode,
});

export const selectTeamMember = (teamMemberId): any => action(types.SELECT_TEAM_MEMBER_REQUESTED, {
  currentTeamMemberId: teamMemberId,
});
export const clearTeamMembers = (): any => action(types.CLEAR_TEAM_MEMBERS);

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createTeamMemberPending: (payload): any => action(types.CREATE_TEAM_MEMBER_PENDING, payload),
  createTeamMemberSuccess: (response): any => action(types.CREATE_TEAM_MEMBER_SUCCESS, {
    teamMembersById: response.entities.teamMembers,
    currentTeamMemberId: response.result,
  }),
  updateTeamMemberPending: (payload): any => action(types.UPDATE_TEAM_MEMBER_PENDING, payload),
  updateTeamMemberSuccess: (response): any => action(types.UPDATE_TEAM_MEMBER_SUCCESS, {
    teamMembersById: response.entities.teamMembers,
    currentTeamMemberId: response.result,
  }),
  updateTeamMemberFailed: (error): any => action(types.UPDATE_TEAM_MEMBER_FAIL, { backendErrors: error }),
  deleteTeamMemberPending: (response): any => action(types.DELETE_TEAM_MEMBER_PENDING, response),
  deleteTeamMemberSuccess: (response): any => action(types.DELETE_TEAM_MEMBER_SUCCESS, {
    currentTeamMemberId: response,
  }),
  getTeamMemberPending: (): any => action(types.GET_TEAM_MEMBER_PENDING, {}),
  getTeamMemberSuccess: (response): any => action(types.GET_TEAM_MEMBER_SUCCESS, {
    teamMembersById: response.entities.teamMembers,
    currentTeamMemberId: response.result,
  }),
  getTeamMemberFailed: (error): any => action(types.GET_TEAM_MEMBER_FAIL, { backendErrors: error }),
  deleteTeamMemberFailed: (error): any => action(types.DELETE_TEAM_MEMBER_FAIL, { backendErrors: error }),
  getAllTeamMembersPending: (pagination): any => action(types.GET_ALL_TEAM_MEMBERS_PENDING, { pagination }),
  getAllTeamMembersSuccess: (response, meta): any => action(types.GET_ALL_TEAM_MEMBERS_SUCCESS, {
    teamMembersById: response.entities.teamMembers,
    teamMemberIds: response.result,
    meta,
  }),
  getAllTeamMembersFailed: (error): any => action(types.GET_ALL_TEAM_MEMBERS_FAIL, { backendErrors: error }),
  createTeamMemberFailed: (error): any => action(types.CREATE_TEAM_MEMBER_FAIL, { backendErrors: error }),
};

export default null;
